/*
 |--------------------------------------------------------------------------
 | Questions / getters.js
 |--------------------------------------------------------------------------
 */

export default {
    boatType: state => state.boatType,
    boatMaterial: state => state.boatMaterial,
    sailFrequency: state => state.sailFrequency,
    country: state => state.country,
    localProducts: state => key => state.localProducts[key]
}
